import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const MIDDLEWARE_URL = process.env.REACT_APP_API_URL;
export default function Tracabilite() {
  const navigate = useNavigate();
  const [alerts, setAlerts] = useState([]);
  const [dashboard, setDashboard] = useState(null);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [modal, setModal] = useState(null);
  const [numInput, setNumInput] = useState("");
  const [retryMsg, setRetryMsg] = useState(null);

  useEffect(() => {
    Promise.all([
      fetch(`${MIDDLEWARE_URL}/tracabilite/alerts`).then(r => r.json()).catch(() => []),
      fetch(`${MIDDLEWARE_URL}/tracabilite/dashboard`).then(r => r.json()).catch(() => null),
    ]).then(([al, dash]) => {
      setAlerts(Array.isArray(al) ? al : al?.alerts || []);
      setDashboard(dash);
      setLoading(false);
    });
  }, []);

  const checkStatus = async (num) => {
    if (!num) return;
    setModal({ type: "status", num, loading: true });
    try {
      const r = await fetch(`${MIDDLEWARE_URL}/tracabilite/${num}/status`);
      const data = await r.json();
      setModal({ type: "status", num, data, loading: false });
    } catch { setModal({ type: "status", num, data: { error: "Erreur" }, loading: false }); }
  };

  const checkHistory = async (num) => {
    if (!num) return;
    setModal({ type: "history", num, loading: true });
    try {
      const r = await fetch(`${MIDDLEWARE_URL}/tracabilite/${num}/history`);
      const data = await r.json();
      setModal({ type: "history", num, data, loading: false });
    } catch { setModal({ type: "history", num, data: { error: "Erreur" }, loading: false }); }
  };

  const manualRetry = async (num) => {
    setRetryMsg(null);
    try {
      const r = await fetch(`${MIDDLEWARE_URL}/retry/manual/${num}`, { method: "POST" });
      const data = await r.json();
      setRetryMsg({ ok: true, msg: `Retry lancé pour #${num}`, data });
    } catch { setRetryMsg({ ok: false, msg: "Erreur lors du retry" }); }
  };

  const STATUT_COLORS = {
    PENDING: { color: "#d97706", bg: "#fef3c7", icon: "⏳" },
    SENT: { color: "#2563eb", bg: "#dbeafe", icon: "📤" },
    ACCEPTED: { color: "#16a34a", bg: "#dcfce7", icon: "✅" },
    REJECTED: { color: "#dc2626", bg: "#fee2e2", icon: "❌" },
    ERROR: { color: "#9333ea", bg: "#f3e8ff", icon: "⚠️" },
  };

  return (
    <div style={{ minHeight: "100vh", background: "#f8fafc", fontFamily: "'Segoe UI', system-ui, sans-serif" }}>
      {/* NAVBAR */}
      <nav style={{
        background: "#fff", borderBottom: "1px solid #e2e8f0", padding: "0 32px",
        display: "flex", alignItems: "center", justifyContent: "space-between", height: 64,
        position: "sticky", top: 0, zIndex: 100, boxShadow: "0 1px 3px rgba(0,0,0,.05)"
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 32 }}>
          <div onClick={() => navigate("/home")} style={{ cursor: "pointer" }}>
            <span style={{ fontSize: 22, fontWeight: 800, background: "linear-gradient(135deg,#6366f1,#8b5cf6)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>⚡ LOGIMES</span>
          </div>
          <div style={{ display: "flex", gap: 4 }}>
            {[["🏠", "Accueil", "/home"], ["👥", "Clients", "/clients"], ["🧾", "Factures", "/factures"], ["📦", "Archive", "/archive"], ["📊", "Dashboard", "/dashboard"]].map(([icon, label, path]) => (
              <button key={path} onClick={() => navigate(path)} style={{
                padding: "6px 14px", borderRadius: 8, border: "none", cursor: "pointer", fontSize: 13, fontWeight: 500,
                background: "transparent", color: "#64748b"
              }}>{icon} {label}</button>
            ))}
          </div>
        </div>
        <button onClick={() => { localStorage.removeItem("token"); navigate("/"); }} style={{ padding: "8px 18px", borderRadius: 8, border: "1.5px solid #e2e8f0", background: "#fff", color: "#64748b", fontSize: 13, fontWeight: 500, cursor: "pointer" }}>Déconnexion</button>
      </nav>

      <div style={{ maxWidth: 1400, margin: "0 auto", padding: "32px 24px" }}>
        <div style={{ marginBottom: 28 }}>
          <h1 style={{ fontSize: 28, fontWeight: 700, color: "#0f172a", margin: 0 }}>🔍 Traçabilité & Alertes</h1>
          <p style={{ color: "#64748b", margin: "6px 0 0", fontSize: 14 }}>Suivi en temps réel du statut de chaque facture</p>
        </div>

        {/* SEARCH FACTURE */}
        <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0", padding: 24, marginBottom: 24 }}>
          <h3 style={{ margin: "0 0 16px", fontSize: 15, fontWeight: 600 }}>🔎 Rechercher une facture</h3>
          <div style={{ display: "flex", gap: 10 }}>
            <input value={numInput} onChange={e => setNumInput(e.target.value)}
              placeholder="N° facture (ex: 21)"
              onKeyDown={e => e.key === "Enter" && checkStatus(numInput)}
              style={{ flex: 1, height: 40, padding: "0 14px", borderRadius: 8, border: "1.5px solid #e2e8f0", fontSize: 13, outline: "none" }} />
            <button onClick={() => checkStatus(numInput)} style={{ padding: "0 20px", height: 40, borderRadius: 8, border: "none", background: "#6366f1", color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>📊 Statut</button>
            <button onClick={() => checkHistory(numInput)} style={{ padding: "0 20px", height: 40, borderRadius: 8, border: "1.5px solid #6366f1", background: "#fff", color: "#6366f1", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>📋 Historique</button>
            <button onClick={() => manualRetry(numInput)} style={{ padding: "0 20px", height: 40, borderRadius: 8, border: "none", background: "#d97706", color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>🔁 Retry</button>
          </div>
          {retryMsg && (
            <div style={{ marginTop: 12, padding: "10px 14px", borderRadius: 8, background: retryMsg.ok ? "#dcfce7" : "#fee2e2", color: retryMsg.ok ? "#16a34a" : "#dc2626", fontSize: 13, fontWeight: 500 }}>
              {retryMsg.ok ? "✅" : "❌"} {retryMsg.msg}
            </div>
          )}
        </div>

        {/* STATUTS REFERENCE */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(5,1fr)", gap: 12, marginBottom: 24 }}>
          {Object.entries(STATUT_COLORS).map(([key, val]) => (
            <div key={key} style={{ background: val.bg, borderRadius: 10, padding: "14px 16px", border: `1px solid ${val.color}22` }}>
              <div style={{ fontSize: 22 }}>{val.icon}</div>
              <div style={{ fontWeight: 700, color: val.color, marginTop: 6, fontSize: 13 }}>{key}</div>
            </div>
          ))}
        </div>

        {/* ALERTS */}
        <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0", padding: 24, marginBottom: 24 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
            <h3 style={{ margin: 0, fontSize: 15, fontWeight: 600 }}>🔔 Alertes Actives ({alerts.length})</h3>
            {alerts.length > 0 && <span style={{ padding: "4px 10px", borderRadius: 20, background: "#fee2e2", color: "#dc2626", fontSize: 12, fontWeight: 600 }}>⚠️ {alerts.length} alerte(s)</span>}
          </div>
          {loading ? <div style={{ color: "#94a3b8" }}>Chargement...</div> :
            alerts.length === 0 ? (
              <div style={{ textAlign: "center", padding: "32px 0", color: "#16a34a" }}>
                <div style={{ fontSize: 40 }}>✅</div>
                <div style={{ marginTop: 10, fontSize: 13 }}>Aucune alerte — tout fonctionne correctement</div>
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                {alerts.map((a, i) => (
                  <div key={i} style={{ padding: "14px 16px", borderRadius: 8, background: "#fef2f2", border: "1px solid #fecaca" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                      <div>
                        <div style={{ fontWeight: 600, color: "#dc2626", fontSize: 13 }}>⚠️ {a.type || a.titre || "Alerte"}</div>
                        <div style={{ color: "#64748b", marginTop: 4, fontSize: 12 }}>{a.message || a.description || JSON.stringify(a)}</div>
                      </div>
                      {a.num_facture && (
                        <button onClick={() => checkStatus(a.num_facture)} style={{ padding: "5px 12px", borderRadius: 6, border: "1.5px solid #dc2626", background: "#fff", color: "#dc2626", fontSize: 12, cursor: "pointer" }}>
                          Voir #{a.num_facture}
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )
          }
        </div>

        {/* DASHBOARD TRACABILITE */}
        {dashboard && (
          <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0", padding: 24 }}>
            <h3 style={{ margin: "0 0 16px", fontSize: 15, fontWeight: 600 }}>📡 Dashboard Traçabilité</h3>
            <pre style={{ margin: 0, fontSize: 11, background: "#0f172a", color: "#e2e8f0", padding: 16, borderRadius: 8, overflow: "auto", maxHeight: 300, lineHeight: 1.5 }}>
              {JSON.stringify(dashboard, null, 2)}
            </pre>
          </div>
        )}
      </div>

      {/* MODAL */}
      {modal && (
        <div onClick={() => setModal(null)} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.45)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
          <div onClick={e => e.stopPropagation()} style={{ background: "#fff", borderRadius: 16, width: "100%", maxWidth: 700, maxHeight: "80vh", display: "flex", flexDirection: "column", boxShadow: "0 25px 50px rgba(0,0,0,.25)" }}>
            <div style={{ padding: "20px 24px", borderBottom: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <h2 style={{ margin: 0, fontSize: 16, fontWeight: 700 }}>
                {modal.type === "status" ? "📊 Statut" : "📋 Historique"} — Facture #{modal.num}
              </h2>
              <button onClick={() => setModal(null)} style={{ border: "none", background: "none", fontSize: 20, cursor: "pointer", color: "#94a3b8" }}>✕</button>
            </div>
            <div style={{ flex: 1, overflow: "auto", padding: 24 }}>
              {modal.loading ? (
                <div style={{ textAlign: "center", padding: 40, color: "#94a3b8" }}>⏳ Chargement...</div>
              ) : (
                <pre style={{ margin: 0, fontSize: 12, background: "#0f172a", color: "#e2e8f0", padding: 20, borderRadius: 10, overflow: "auto", lineHeight: 1.6 }}>
                  {JSON.stringify(modal.data, null, 2)}
                </pre>
              )}
            </div>
          </div>
        </div>
      )}
      <style>{`* { box-sizing: border-box; }`}</style>
    </div>
  );
}


